module.exports = __webpack_public_path__ + "img/desktop/Background-freespins/fsbackground@2x.jpg?1.0.17";